// extracted by mini-css-extract-plugin
module.exports = {"ChartSize":"SubmissionGraph_ChartSize__3uiL-"};